import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import * as ChartDataLabels from 'chartjs-plugin-datalabels';
import { UtilsService } from '../services/utils/utils.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { SignInData } from '../model/signInData';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  message: any = {};
  isLoadingClientChannel: boolean = false
  isLoadingClientChannelAdoption: boolean = false
  isLoadingMessageUsage: boolean = false

  // Dialog display varaible
  displayRenewModal: boolean = false;
  //Chart
  clientChannelData: any;
  clientChannelAdoptionData: any;
  messageUsageData: any;
  //
  noClientChannelData: boolean = false;
  noClientChannelAdoptionData: boolean = false;
  noMessageUsageData: boolean = false;
  //
  options: any;
  basicOptions: any;
  plugin: any[] = [];
  TOKEN: any = '';
  constructor(
    public utils: UtilsService,
    private dashboardService: DashboardService,
    private messageService: MessageService,
  ) {
    this.plugin.push(ChartDataLabels);
    // this.options = {
    //   plugins: {
    //     datalabels: {
    //       /* show value in percents */
    //       formatter: (value: any, ctx: any) => {
    //         let sum = 0;
    //         const dataArr = ctx.chart.data.datasets[0].data;
    //         dataArr.map((data: any) => {
    //           sum += data;
    //         });
    //         const percentage = (value * 100 / sum);
    //         return percentage !== 0 ? percentage.toFixed(2) + '%' : '';
    //       },
    //       color: '#fff',
    //     }
    //   }
    // }
    this.options = {
      //display labels on data elements in graph
      plugins: {
        datalabels: {
          formatter: (value: any, ctx: any) => {
            return ctx.chart.data.displayData[ctx.dataIndex];
          },
          align: 'center',
          anchor: 'center',
          borderRadius: 4,
          backgroundColor: 'transparent',
          color: ['white', '#8E8E93'],
          font: {
            weight: 'bold',
          },
        },
      },
    };


    this.basicOptions = {
      plugins: {
        datalabels: {
          formatter: (value: any, ctx: any) => {
            return ctx.chart.data.displayData[ctx.dataIndex];
          },
          align: 'center',
          anchor: 'center',
          borderRadius: 4,
          backgroundColor: 'transparent',
          color: '#8E8E93',
          font: {
            weight: 'bold',
          },
        },
      },
      legend: {
        labels: {
          fontColor: '#495057'
        }
      },
      scales: {
        xAxes: [{
          ticks: {
            fontColor: '#495057'
          }
        }],
        yAxes: [{
          ticks: {
            fontColor: '#495057',
            min: 0,
            max: 100
          }
        }]
      }
    };
  }

  ngOnInit(): void {
    this.getClientChannel()
    this.getClientChannelAdoption()
    this.getMessageUsage()
  }


  getClientChannel() {
    this.isLoadingClientChannel = true
    this.dashboardService.getClientChannel().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log("Client Channel Response --->> " + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.isLoadingClientChannel = false;
          this.noClientChannelData = json.data.every((data: any) => {
            return data.data == '0';
          });
          this.clientChannelData = {
            labels: this.getLabels(json.data),
            displayData: this.getDisplayData(json.data),
            datasets: [
              {
                data: this.getData(json.data),
                backgroundColor: [
                  "#3979FA",
                  "#DEE2E6"
                ],
                hoverBackgroundColor: [
                  "#3979FA",
                  "#DEE2E6"
                ]
              }]
          };
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getClientChannelAdoption() {
    this.isLoadingClientChannelAdoption = true
    this.dashboardService.getClientChannelAdoption().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log("Client Channel Adoption Response --->> " + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.isLoadingClientChannelAdoption = false
          this.noClientChannelAdoptionData = json.data.every((data: any) => {
            return data == '0';
          });
          this.clientChannelAdoptionData = {
            labels: this.getLabels(json.data),
            displayData: this.getDisplayData(json.data),
            datasets: [
              {
                data: this.getData(json.data),
                backgroundColor: [
                  "#3979FA",
                  "#DEE2E6"
                ],
                hoverBackgroundColor: [
                  "#3979FA",
                  "#DEE2E6"
                ]
              }]
          };

        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMessageUsage() {
    this.isLoadingMessageUsage = true
    this.dashboardService.getMessageUsage().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log("Message Usage Response --->> " + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.isLoadingMessageUsage = false
          this.noMessageUsageData = json.data.every((data: any) => {
            return data == '0';
          });
          this.messageUsageData = {
            labels: this.getBarLabels(json.data),
            displayData: this.getDisplayData(json.data),
            datasets: [
              {
                label: 'SMS',
                backgroundColor: '#DEE2E6',
                data: this.getData(json.data)
              }
            ]
          };
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getLabels(data: any) {
    return data.map(function (val: any) {
      return val.datasetName;
    });
  }

  getData(data: any) {
    return data.map(function (val: any) {
      return parseInt(val.data);
    });
  }

  getBarLabels(data: any) {
    return data.map(function (val: any) {
      return val.xAxis;
    });
  }

  getDisplayData(data: any) {
    return data.map(function (val: any) {
      return val.displayData;
    });
  }

  showSuccessMessage(msg: string) {
    this.messageService.add({
      key: "successMsg",
      severity: "success",
      detail: msg,
    });
  }


  get state(): string {
    return this.utils.state;
  }
}
